import React from 'react';
import { Input } from '../ui/Input';
import { Select } from '../ui/Select';
interface HeaderTabProps {
  data: {
    groupId: string;
    groupName: string;
    status: string;
  };
  onChange: (field: string, value: string) => void;
}
export function HeaderTab({
  data,
  onChange
}: HeaderTabProps) {
  return <div className="max-w-2xl mx-auto space-y-6 py-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-392">
      <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm space-y-6" data-id="element-393">
        <div data-id="element-394">
          <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-395">
            KYC Group Details
          </h3>
          <div className="space-y-4" data-id="element-396">
            <Input label="KYC Group ID" value={data.groupId} onChange={e => onChange('groupId', e.target.value)} placeholder="e.g., KYC-001" data-id="element-397" />

            <Input label="KYC Group Name" value={data.groupName} onChange={e => onChange('groupName', e.target.value)} placeholder="e.g., Standard Individual KYC" data-id="element-398" />

            <Select label="Status" value={data.status} onChange={e => onChange('status', e.target.value)} options={[{
            value: 'active',
            label: 'Active'
          }, {
            value: 'inactive',
            label: 'Inactive'
          }]} data-id="element-399" />
          </div>
        </div>
      </div>
    </div>;
}